import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  EditButton,
  DateField,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  BooleanField,
  BooleanInput,
  NumberInput,
  NumberField
} from 'react-admin';

export const ImageFormatter = v => {
  // console.log("====LogoFormatter=====: ", v);
  if (typeof v === 'object') {
    return v;
  }
  const imageObj = {
    "src": v
  }
  return v
    ? imageObj
    : v;
}

export const ImageParser = v => {
  // console.log("====LogoParser=====: ", v);
  // console.log(v);
  if (typeof v === 'object') {
    return v;
  }

  return v.src
    ? v.src
    : v;
}

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const ScreenList = (props) => (
  <List {...props} title="List of Screens" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="app_name"/>
      <TextField source="app_description"/>
      <TextField source="app_url"/>
      <BooleanField source="it_self"/>
      <NumberField source="order"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const ScreenCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/screens">
      <TextInput source="app_name" />
      <TextInput source="app_description"/>
      <TextInput source="app_url"/>
      <BooleanInput source="it_self"/>
      <ImageInput source="app_icon" label="App Icon" accept="image/*"
                  format={ImageFormatter} parse={ImageParser}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="app_banner" label="App Banner" accept="image/*"
                  format={ImageFormatter} parse={ImageParser}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <NumberInput source="order"/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const ScreenEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/screens">
      <FormTab label="Screen Info">
        <TextInput source="app_name" />
        <TextInput source="app_description"/>
        <TextInput source="app_url"/>
        <BooleanInput source="it_self"/>
        <ImageInput source="app_icon" label="App Icon" accept="image/*"
                    format={ImageFormatter} parse={ImageParser}>
          <ImageField source="src" title="title"/>
        </ImageInput>
        <ImageInput source="app_banner" label="App Banner" accept="image/*"
                    format={ImageFormatter} parse={ImageParser}>
          <ImageField source="src" title="title"/>
        </ImageInput>
        <NumberInput source="order"/>
      </FormTab>
    </TabbedForm>
  </Edit>
);